import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import PalashKusumChakma from "../../../images/Photos/Palash-kusum-chakma.jpg";
import SushovanChakma from "../../../images/Photos/Sushovan Chakmaa.JPG";
import koalKhisa from "../../../images/Photos/Person_image.jpg";
import BiplobBanerjee from "../../../images/Photos/Person_image.jpg";
import BhubonChakma from "../../../images/Photos/Person_image.jpg";
import "../../../style/about/smt.css";
import Zoom from "react-reveal/Zoom";
import TranslateButton from "../../TranslateButton/TranslateButton";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const SMT = () => {
  useEffect(() => {
    document.title = `Development Concern | Senior Management Team`;
  }, []);

  // const shareUrl = "https://developmentconcerncht.org/about/senior-management-team";

  return (
    <>
      <Navbar />
      {/* <TranslateButton /> */}

      <div className="senior_management_team_section">
        <div className="header_image">
          <p>Home | About</p>
          <h2>Senior Management Team</h2>
        </div>

        {/* Header Background Part Start */}
        {/* <div className="header_background">
          <div className="container wrapper">
            <h2>Senior Management Team</h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div> */}
        {/* Header Background Part End */}

        <div className="container">
          <h1>Senior Management Team</h1>
          <div className="title_header">
            <p>
              The Senior Management Team (SMT) provides day to day leadership
              for the organization such as determining strategic, programmatic
              and operational issues and delivery against action plan and budget
              of Ashroy Angon Society's projects/programmes as implementing
              authority of EC. SMT is accountable to EC for outcomes and
              exercise of authority.
            </p>
          </div>

          <div className="Ed_image">
            <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={PalashKusumChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Palash Kusum Chakma, MBA</h4>
                  <p>Executive Director (ED)</p>
                </div>
              </div>
            </Zoom>
          </div>

          <div className="content_wrapper">
            <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={SushovanChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Sushovan Chakma, MA</h4>
                  <p>
                    Deputy Executive Director (DED)
                  </p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={koalKhisa} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Chakma, MBA</h4>
                  <p>
                    Manager Admin
                  </p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={koalKhisa} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Marma, MA</h4>
                  <p>
                    Manager, Finance & Account
                  </p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={koalKhisa} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Hasan, MBA</h4>
                  <p>Manager MEAL & Reporting</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={BiplobBanerjee} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Banerjee MBA</h4>
                  <p>Manager IGA</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_wrapper">
                <img src={BhubonChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Chakma, MBA</h4>
                  <p>Project Manager</p>
                </div>
              </div>
            </Zoom>

          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SMT;
